import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-data-card-lilly',
  templateUrl: './data-card-lilly.component.html',
  styleUrls: ['../../../home/components/data-card/data-card.component.less'],
})
export class DataCardLillyComponent implements OnInit {

  age = new Number;

  constructor() {
  }

  ngOnInit(): void {
      this.age = Math.floor(((Date.now() - new Date('June 25, 2016 00:00:00').getTime()) / (1000 * 3600 * 24))/365);
  }

}